<template>
  <div class="page-container">
    <div class="main">
      <page :url="url" :form="form" :formRules="formRules" @reset="reset">
        <template slot="tableSearch">
          <el-form-item v-if="ROLE_TYPE.isManager()"
                        :label="$t('text.agent')">
            <el-select v-model="form.agentId"
                       filterable
                       clearable
                       :placeholder="$t('message.chooseOne')"
                       popper-class="eloption">
              <el-option :label="$t('option.all')"
                         value=""/>
              <el-option v-for="item in agentList"
                         :key="item.agentId"
                         :label="item.agentId + '-' + item.agentName"
                         :value="item.agentId"/>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('text.date')" prop="timeDate">
            <el-date-picker v-model="timeDate"
                            type="daterange"
                            format="yyyy-MM-dd"
                            value-format="yyyyMMdd"
                            :range-separator="$t('text.to')"
                            :start-placeholder="$t('text.startDate')"
                            :end-placeholder="$t('text.endDate')"
                            @change="timeChange"
            />
          </el-form-item>
        </template>

        <template slot="buttonArea">
          <el-button :loading="loading"
                     type="primary"
                     @click="exportDetail"
                     size="small">
            {{ $t('text.export') }}
          </el-button>
        </template>

        <template slot="tableColumn">
          <el-table-column width="120px"
                           prop="statisticsDate"
                           :label="$t('text.date')"
                           :formatter="$formatter.formatDate"
                           align="center"/>
          <el-table-column width="150"
                           prop="updateTimeL"
                           :label="$t('text.updateTime')"
                           :formatter="$formatter.formatDate"
                           align="center"/>
          <el-table-column width="120px"
                           prop="paymentAmount"
                           :formatter="$formatter.FenToYuanToThousandth"
                           :label="$t('text.collectionAmount')"
                           align="center"/>
          <el-table-column width="120px"
                           prop="paymentFee"
                           :formatter="$formatter.FenToYuanToThousandth"
                           :label="$t('text.collectionFee')"
                           align="center"/>
          <el-table-column prop="paymentAgentFee"
                           width="120px"
                           :formatter="$formatter.FenToYuan3ToThousandth"
                           :label="$t('text.agentBalance')"
                           align="center"/>
          <el-table-column width="90px"
                           prop="paymentCountSuccess"
                           :label="$t('text.collectionSuccessCount')"
                           align="center"/>

          <el-table-column prop="" width="30px" label="|" align="center">|</el-table-column>

          <el-table-column width="120px"
                           prop="transferAmount"
                           :formatter="$formatter.FenToYuanToThousandth"
                           :label="$t('text.disbursementAmount')"
                           align="center"/>
          <el-table-column width="120px"
                           prop="transferFee"
                           :formatter="$formatter.FenToYuanToThousandth"
                           :label="$t('text.disbursementFee')"
                           align="center"/>
          <el-table-column prop="transferAgentFee"
                           width="100px"
                           :formatter="$formatter.FenToYuan3ToThousandth"
                           :label="$t('text.agentBalance')"
                           align="center"/>
          <el-table-column width="120px"
                           prop="transferCountSuccess"
                           :label="$t('text.disbursementSuccessCount')"
                           align="center"/>

          <el-table-column prop="" width="30px" label="|" align="center">|</el-table-column>

          <el-table-column width="120px"
                           prop="depositAmount"
                           :formatter="$formatter.FenToYuanToThousandth"
                           :label="$t('text.rechargeAmount')"
                           align="center"/>
          <el-table-column width="120px"
                           prop="withdrawAmount"
                           :formatter="$formatter.FenToYuanToThousandth"
                           :label="$t('text.withdrawalAmount')"
                           align="center"/>

          <el-table-column prop="" width="30px" label="|" align="center">|</el-table-column>

          <el-table-column width="120px"
                           prop="channelBalance"
                           :formatter="$formatter.FenToYuanToThousandth"
                           :label="$t('text.bankBalance')"
                           align="center"/>
          <el-table-column width="120px"
                           prop="merBalance"
                           :formatter="$formatter.FenToYuanToThousandth"
                           :label="$t('text.merchantBalance')"
                           align="center"/>
          <el-table-column width="120px"
                           prop="platformBalance"
                           :formatter="$formatter.FenToYuanToThousandth"
                           :label="$t('text.platformBalance')"
                           align="center"/>
        </template>
      </page>
    </div>
  </div>
</template>
<script>
import Page from "@/components/Page.vue";
import moment from "moment";
import {ROLE_TYPE} from "@/utils/Constant";

export default {
  computed: {
    ROLE_TYPE() {
      return ROLE_TYPE
    }
  },
  components: {
    page: Page,
  },
  data() {
    return {
      url: "/statistics-platform/listStatisticsPlatform",
      merchantList: [],
      agentList: [],
      form: {
        appId: "",
        startDate: "",
        endDate: "",
        tradeOrderId: "",
      },
      timeDate: [],
      loading: false,
      formRules: {
        timeDate: [
          {validator: this.validateDateRange, trigger: ['blur', 'change']}
        ]
      }
    };
  },
  methods: {
    timeChange(e) {
      if (e) {
        this.form.startDate = e[0];
        this.form.endDate = e[1];
      } else {
        this.form.startDate = "";
        this.form.endDate = "";
      }
    },
    reset() {
      let start = moment().subtract(0, 'days').format('yyyyMMDD');
      let end = moment().format('yyyyMMDD');
      this.form.startDate = start;
      this.form.endDate = end;
      this.timeDate = [start, end];
    },

    exportDetail() {
      this.loading = true
      this.axios
          .get('/statistics-platform/listStatisticsPlatformExport', {
            params: this.form,
          })
          .then(res => {
            if (res.code !== 200) {
              this.$message({
                message: res.msg,
                type: 'error',
              })
            } else {
              this.$message({
                message: res.msg,
                type: 'success',
              })
            }
          })
      this.loading = false
    },
    validateDateRange(rule, value, callback) {
      if (!this.timeDate || this.timeDate.length !== 2) {
        callback(new Error(this.$t('message.chooseDay')));
      } else {
        // const start = this.timeDate[0];
        // const end = this.timeDate[1];
        // const startDay = new Date(start.slice(0, 4), start.slice(4, 6) - 1, start.slice(6, 8));
        // const endDay = new Date(end.slice(0, 4), end.slice(4, 6) - 1, end.slice(6, 8));
        // const diffDays = Math.ceil(Math.abs(endDay - startDay) / (1000 * 60 * 60 * 24));
        // if (diffDays > 2) {
        //   callback(new Error(this.$t('message.dateRangeCannotExceed2Days')));
        // } else {
        //   callback();
        // }
        callback();
      }
    },
  },

  created() {
    let start = moment().subtract(0, 'days').format('yyyyMMDD');
    let end = moment().format('yyyyMMDD');
    this.form.startDate = start;
    this.form.endDate = end;
    this.timeDate = [start, end];

    this.$axios.get('/agent/selectAgentForOption', {params: {}})
        .then(res => {
          this.agentList = res.data
        })
  },
};
</script>
<style lang="scss" scoped>
.remark {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}

.el-form-item {
  margin-bottom: 5px;
}
</style>